import { ManifestGoodsInfo } from '@/class/model/booking/ManifestGoodsInfo'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import lang from '@/lang'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'
import { getRongeTongShipAgent, getShipAgent, getWseShipAgent } from '@/api/seaExport/manifestInfo'
import { ediQueryMappings } from '@/api/sysManage/baseConfig/mappingManage'
import { SENDING_THAILAND, WSE_MANIFEST } from '@/class/cargo/model/parameters/SystemConstants'
import CommonState from '@/class/cargo/model/parameters/CommonState'
import fa from 'element-ui/src/locale/lang/fa'

/**
 * 海管家船公司
 * @type {string[]}
 */
export const SEA_HOUSE_CARRIER_COMPANY = ['APL', 'ASL', 'BAL', 'BLPL', 'BSL', 'BTLS',
  'BTL', 'ANL', 'CL', 'CMA', 'CNC', 'COH', 'CSL', 'CST', 'CUL', 'DY', 'EMC/EVG',
  'ESL', 'FSL', 'FESCO/FSC', 'GFS', 'HAL', 'HSD/HAM', 'HSLI', 'HMM', 'HLC/HPL',
  'HLD', 'IAL', 'IDL', 'JOT', 'KKC', 'KMTC/KMT', 'MAT', 'MBF', 'MEL', 'MIA', 'MSK/MCC/SAF',
  'NDS', 'NNS', 'NOS', 'NSI', 'NZL', 'ONE', 'OOCL', 'PEL', 'PIL', 'PMA', 'RCL', 'SCI',
  'SCO', 'SLS', 'SMH', 'SML', 'SNKO', 'SNL', 'SOF', 'SSL', 'STX/POL', 'SWIR', 'SWL', 'SUM',
  'TJM', 'TSL/TSC', 'TYS', 'UNL', 'WHL', 'WOSCO', 'YML', 'ZGXL', 'ZIM/GOLD STAR']
/**
 * 海管家船代
 * @type {string[]}
 */
export const SEA_HOUSE_CARRIER_AGENT_COMPANY = ['132210843', 'MA1G5DJT4', '13453884-2', '132208081', '750314826', '132230158', '150016700', '560100333', '71785140-0', '717859429', '133747781', 'OOCL', '70305128-5']

/**
 * 舱单发送通道
 * @type {CommonState}
 */
export const OTHER_CHANNEL = new CommonState(0, '其他', 'other')
export const SEA_HOUSE_CHANNEL = new CommonState(1, '海管家', 'sea house')
export const WSE_CHANNEL = new CommonState(2, '未斯', 'wse')
export const RONGE_TONG_CHANNEL = new CommonState(3, '荣e通', 'rongeTong')

/**
 * 海管家运输条款
 * @type {string[]}
 */
export const SEA_HOUSE_FREIGHT_TERM = ['CFS-CFS', 'CFS-CY', 'CFS-DOOR', 'CY-CFS', 'CY-CY', 'CY-DOOR', 'CY-FREE OUT', 'CY-LINER OUT', 'CY-RAMP', 'CY-SHIPS HOOK', 'CY-TACKLE', 'DOOR-CFS', 'DOOR-CY', 'DOOR-DOOR', 'DOOR-RAMP', 'DR-FREE OUT', 'DR-LINER OUT', 'FEE IN-CY', 'FREE IN-D', 'LINER IN-CY', 'LINER IN-DR', 'RAMP-CFS', 'RAMP-CY', 'RAMP-RAMP', 'TACKLE-CFS', 'TACKLE-CY']

/**
 * 海管家货物类型
 * @type {string[]}
 */
export const SEA_HOUSE_CARGO_TYPE = ['GC', 'RF', 'DR']

/**
 * 海管家船公司映射
 * @type {{NZL: string, IDL: string, NNS: string, DY: string, CMA: string, TJM: string, BSL: string, WHL: string, CUL: string, SLS: string, FSL: string, 'KMTC/KMT': string, MIA: string, NSI: string, SWIR: string, SUM: string, JOT: string, SMH: string, 'TSL/TSC': string, NOS: string, SML: string, 'MSK/MCC/SAF': string, IAL: string, MEL: string, 'FESCO/FSC': string, CNC: string, YML: string, RCL: string, BTL: string, ANL: string, HLD: string, MAT: string, 'HLC/HPL': string, 'ZIM/GOLDSTAR': string, BTLS: string, ONE: string, WOSCO: string, ZGXL: string, 'HSD/HAM': string, MBF: string, SNL: string, UNL: string, GFS: string, BLPL: string, SNKO: string, ASL: string, NDS: string, COH: string, CSL: string, ESL: string, 'STX/POL': string, KKC: string, CST: string, PMA: string, CL: string, HSLI: string, HMM: string, SWL: string, SOF: string, OOCL: string, BAL: string, SSL: string, TYS: string, HAL: string, PIL: string, PEL: string, SCI: string, 'EMC/EVG': string, APL: string, SCO: string}}
 */
export const SEA_HOUSE_SHIP_COMPANY = { 'APL': 'APL—美国总统', 'ASL': 'ASL—亚海', 'BAL': 'BAL—博亚', 'BLPL': 'BLPL—新加坡私立', 'BSL': 'BSL—巴拉基', 'BTLS': 'BTLS—孟虎上海', 'BTL': 'BTL—孟虎航运公司', 'ANL': 'ANL—澳航', 'CL': 'CL—中通', 'CMA': 'CMA—达飞', 'CNC': 'CNC—正利', 'COH': 'COH—京汉', 'CSL': 'CSL—晶品', 'CST': 'CST—宝华', 'CUL': 'CUL—中联运通', 'DY': 'DY—东映', 'EMC/EVG': 'EMC/EVG—长荣', 'ESL': 'ESL—阿联酋', 'FSL': 'FSL—达飞伯辽兹', 'FESCO/FSC': 'FESCO/FSC—俄远东', 'GFS': 'GFS—格飞驰', 'HAL': 'HAL—兴亚', 'HSD/HAM': 'HSD/HAM—汉堡南美', 'HSLI': 'HSLI—韩星海运株式会社', 'HMM': 'HMM—现代', 'HLC/HPL': 'HLC/HPL—赫伯罗特', 'HLD': 'HLD—海隆达', 'IAL': 'IAL—运达', 'IDL': 'IDL—印达斯', 'JOT': 'JOT—君安', 'KKC': 'KKC—神原', 'KMTC/KMT': 'KMTC/KMT—高丽', 'MAT': 'MAT—美森', 'MBF': 'MBF—卡朋特', 'MEL': 'MEL—玛丽安娜', 'MIA': 'MIA—香港璟荣船务', 'MSK/MCC/SAF': 'MSK/MCC/SAF—马士基', 'NDS': 'NDS—尼罗河', 'NNS': 'NNS—洋浦良恩', 'NOS': 'NOS—新东', 'NSI': 'NSI—宁波远洋', 'NZL': 'NZL—新西兰航运', 'ONE': 'ONE—海洋网联', 'OOCL': 'OOCL—东方海外', 'PEL': 'PEL—新加坡', 'PIL': 'PIL—太平', 'PMA': 'PMA—普洱玛', 'RCL': 'RCL—宏海箱运', 'SCI': 'SCI—印度国航', 'SCO': 'SCO—新加坡海运', 'SLS': 'SLS—新加坡海领船务', 'SMH': 'SMH—司马泰', 'SML': 'SML—森罗', 'SNKO': 'SNKO—长锦', 'SNL': 'SNL—中外运', 'SOF': 'SOF—顺发', 'SSL': 'SSL—萨姆达拉', 'STX/POL': 'STX/POL—泛奥昇', 'SWIR': 'SWIR—太古', 'SWL': 'SWL—盛威航运', 'SUM': 'SUM—萨米特', 'TJM': 'TJM—天津津海', 'TSL/TSC': 'TSL/TSC—德翔', 'TYS': 'TYS—太荣', 'UNL': 'UNL—联合航运', 'WHL': 'WHL—万海', 'WOSCO': 'WOSCO—西联', 'YML': 'YML—阳明', 'ZGXL': 'ZGXL—中谷东海', 'ZIM/GOLDSTAR': 'ZIM/GOLDSTAR—以星' }

/**
 * 海管家船公司船代映射
 * @type {{NZL: string, 'ZIM/GOLD STAR': string, IDL: string, NNS: string, DY: string, TJM: string, CMA: string, 'CMA/ANL': string, BSL: string, WHL: string, SLS: string, CUL: string, FSL: string, 'KMTC/KMT': string, MIA: string, NSI: string, SWIR: string, SUM: string, JOT: string, SMH: string, 'TSL/TSC': string, NOS: string, SML: string, 'MSK/MCC/SAF': string, MEL: string, IAL: string, 'FESCO/FSC': string, CNC: string, YML: string, RCL: string, BTL: string, ANL: string, MAT: string, HLD: string, 'HLC/HPL': string, COSCO: string, BTLS: string, ONE: string, WOSCO: string, ZGXL: string, 'HSD/HAM': string, MBF: string, SNL: string, UNL: string, GFS: string, SNKO: string, BLPL: string, ASL: string, NDS: string, MSC: string, COH: string, CSL: string, ESL: string, 'STX/POL': string, KKC: string, CST: string, PMA: string, HMM: string, HSLI: string, SWL: string, CL: string, SOF: string, OOCL: string, BAL: string, SSL: string, TYS: string, HAL: string, PIL: string, PEL: string, SCI: string, 'EMC/EVG': string, APL: string, SCO: string}}
 */
export const SEA_HOUSE_SHIP_COMPANY_TO_CARRIER_AGENT = { 'APL': '上港联合/上海顺德/上海航华', 'ASL': '上海外代/上海中联', 'BAL': '上港联合', 'BSL': '上海顺德', 'BTL': '上海中外运', 'CMA/ANL': '上港联合/上海华港/上海外代/上海中外运/上海航华', 'CNC': '上海外代/上海顺德', 'COH': '上海外代', 'CST': '上海外代', 'DY': '上海中外运', 'EMC/EVG': '上海航华', 'ESL': '上海华港', 'FESCO/FSC': '上海外代', 'GFS': '上海中外运', 'HAL': '上海中外运/上海外代/上海振华/上海锦诚', 'HSD/HAM': '上海鹏华/上海航华', 'HMM': '上海鹏海', 'HLC/HPL': '上港联合/上海华港/上海中联', 'KKC': '上海外代', 'KMTC/KMT': '上海中外运/上海外代', 'MAT': '上港联合', 'MBF': '上海中外运', 'MEL': '上海中外运', 'MSK/MCC/SAF': '上港联合', 'NDS': '上海航华', 'NOS': '上海外代', 'NSI': '上海外代', 'NZL': '上海振华', 'ONE': '上港联合/上海华港/上海中外运/上海外代/上海中联', 'OOCL': '东方海外', 'PIL': '上海外代/上海华港/上海中外运/上海联合', 'PMA': '上海顺德', 'RCL': '上海顺德/上海外代/上海中外运/上海华港', 'SCI': '上海外代', 'SCO': '上海外代/上海华港', 'SLS': '上海华港', 'SMH': '上海顺德', 'SML': '上海中外运/上港联合', 'SNKO': '上海中外运', 'SNL': '上海中外运', 'SOF': '上海外代', 'SSL': '上海外代', 'STX/POL': '上海中外运', 'TSL/TSC': '上海外代/上海中联', 'TYS': '上海中外运', 'WHL': '上港联合/上海中联/上海华港/上海顺德/上海外代', 'WOSCO': '上海中外运', 'YML': '上港联合/上海中联/上海中外运/上海顺德/上海外代', 'ZIM/GOLD STAR': '上海航华', 'SWIR': '上海中外运/上海鹏华', 'TJM': '上海航华', 'CSL': '上海中外运', 'PEL': '上海顺德', 'HSLI': '上海中外运', 'MSC': '上海联东', 'COSCO': '中远海', 'MIA': '上海中联', 'UNL': '上海外代', 'HLD': '上海顺德', 'SUM': '上海中外运', 'SWL': '上海顺德', 'ANL': '上海华港/上海中外运/上海顺德', 'CMA': '上港联合/上海华港/上海外代/上海中外运/上海航华/上海顺德', 'IDL': '上海顺德', 'CUL': '上海顺德', 'BLPL': '上海顺德', 'BTLS': '上海中外运', 'ZGXL': '上港联合', 'CL': '上海外代', 'JOT': '上港联合', 'IAL': '上海中联', 'FSL': '上海顺德/上港联合', 'NNS': '上港联合' }

/**
 * 港口
 * @type {({code: string, name: string}|{code: string, name: string}|{code: string, name: string}|{code: string, name: string}|{code: string, name: string})[]}
 */
// 动态加载避免构建时解析大文件
export const SEA_PORT = []

// 异步初始化港口数据
const initSeaPort = async() => {
  if (SEA_PORT.length === 0) {
    try {
      const seaPortData = await import('./sea-port.json')
      SEA_PORT.push(...(seaPortData.default || seaPortData))
    } catch (error) {
      console.error('加载港口数据失败:', error)
    }
  }
}

// 立即执行初始化
initSeaPort()

/**
 * 预配舱单工具类
 */
export class PrePlanBookingUtil {
  /**
   * 同步导入信息
   * @param item
   * @param manifestInfo
   */
  static syncImportInfo(item, manifestInfo) {
    this.syncInfo(manifestInfo, item)
    this.syncCustomerShippingInformation(manifestInfo, item)
    /* 覆盖旧的舱单格式化货物信息 */
    this.removeOldData(manifestInfo, 'manifestGoods', item.manifestGoods)
    /* 覆盖旧的舱单格式化VGM信息 */
    this.removeOldData(manifestInfo, 'manifestVGMs', item.manifestVGMs)
  }
  static removeOldData(manifestInfo, field, newData) {
    newData = newData || []
    const data = manifestInfo[field] || []
    for (let i = data.length - 1; i >= 0; --i) {
      if (data[i].uuid) {
        data[i].deleted = true
      } else {
        data.splice(i, 1)
      }
    }
    data.push(...newData)
    manifestInfo[field] = data
  }
  static syncInfo(manifestInfo, item) {
    if (item.importType === 1 || item.importType === 2 || item.importType === 3 || item.importType === 4) {
      const keys = ['mblNo', 'portOfLoading', 'portOfDischarge', 'portOfDestination', 'thirdPartyCargoType',
        'thirdPartyPaymentMethod', 'placeOfPayment', 'sailingDate',
        'bargeVessel', 'bargeVoyage', 'blNumber', 'signPlaceBL', 'signDateBL', 'thirdPartyCarrier',
        'thirdPartyCarrierAgent', 'thirdPartyBlType', 'dispatchingPlaceCode', 'importTempUuid']
      for (const key of keys) {
        if (key === 'importTempUuid' && manifestInfo.importTempUuid && manifestInfo.importTempUuid !== item.importTempUuid) {
          continue
        }
        if (item[key]) {
          manifestInfo[key] = item[key]
        }
      }
    }
    if (item.importType === 0 && item.importTempUuid && !manifestInfo.importTempUuid) {
      manifestInfo.importTempUuid = item.importTempUuid
    }
  }

  /**
   * 获取海管家船公司
   * @param allCompany
   * @returns {[]}
   */
  static getSeaHouseCarrierSeaPorts(allCompany) {
    return this.getSeaHouseCompany(allCompany, SEA_HOUSE_CARRIER_COMPANY)
  }
  /**
   * 获取海管家船代
   * @param allCompany
   * @returns {[]}
   */
  static getSeaHouseCarrierAgentSeaPorts(allCompany) {
    return this.getSeaHouseCompany(allCompany, SEA_HOUSE_CARRIER_AGENT_COMPANY)
  }
  static getSeaHouseCompany(allCompany, seaHouseConstants) {
    const seaHouseMap = this.listToMap(seaHouseConstants)
    const seaHouseCompany = []
    for (const company of allCompany) {
      if (seaHouseMap.hasOwnProperty(company.shortName) || seaHouseMap.hasOwnProperty(company.cnShortName)) {
        seaHouseCompany.push(company)
      }
    }
    return seaHouseCompany
  }
  static getSeaHouseShipCompanyCode(company) {
    if (SEA_HOUSE_SHIP_COMPANY.hasOwnProperty(company.cnShortName)) {
      return company.cnShortName
    }
    if (SEA_HOUSE_SHIP_COMPANY.hasOwnProperty(company.shortName)) {
      return company.shortName
    }
    return ''
  }
  static getSeaHouseShipCompanyAgent(code) {
    if (SEA_HOUSE_SHIP_COMPANY_TO_CARRIER_AGENT.hasOwnProperty(code)) {
      return SEA_HOUSE_SHIP_COMPANY_TO_CARRIER_AGENT[code]
    }
    return ''
  }
  static getSeaHouseShipCompanyAgentCode(company) {
    const constantMap = this.listToMap(SEA_HOUSE_CARRIER_AGENT_COMPANY)
    if (constantMap.hasOwnProperty(company.cnShortName)) {
      return company.cnShortName
    }
    if (constantMap.hasOwnProperty(company.shortName)) {
      return company.shortName
    }
    return ''
  }

  /**
   * 获取海管家运输条款
   * @param shippingTerms
   * @returns {[]}
   */
  static getSeaHouseShippingTerms(shippingTerms) {
    return this.getListWithCode(shippingTerms, SEA_HOUSE_FREIGHT_TERM)
  }
  static isExists(code, constants) {
    const constantMap = this.listToMap(constants)
    return constantMap[code]
  }
  /**
   * 获取海管家运费条款
   * @param shippingTerms
   * @returns {[]}
   */
  static getSeaHouseCargoTypes(list) {
    const seaExportList = list.filter(p => p.sea)
    return this.getListWithChineseName(seaExportList, SEA_HOUSE_CARGO_TYPE)
  }
  static getListWithCode(allList, constants) {
    const constantMap = this.listToMap(constants)
    const results = []
    for (const constant of allList) {
      if (constantMap.hasOwnProperty(constant.code)) {
        results.push(constant)
      }
    }
    return results
  }
  static getListWithChineseName(allList, constants) {
    const constantMap = this.listToMap(constants)
    const results = []
    for (const constant of allList) {
      if (constantMap.hasOwnProperty(constant.chineseName)) {
        results.push(constant)
      }
    }
    return results
  }
  static listToMap(list) {
    const map = {}
    for (const code of list) {
      map[code] = true
    }
    return map
  }

  /**
   * 同步箱货信息
   * @param containerUsages
   * @param rowData
   * @param job
   * @returns {[]}
   */
  static async syncContainer(containerUsages, rowData, job, manifestInfo, isSeaHouseChannel, ediPkList = [], ediEqList = []) {
    const newManifestGoodsInfos = []
    const oldMap = {}
    let hasEmptyBox = false
    for (const item of containerUsages) {
      if (!item.container.containerNo && !(job.masterFlag ? item.soNo : job.soNo)) {
        hasEmptyBox = true
      }
    }
    if (rowData && rowData.length > 0) {
      for (const data of rowData) {
        // 来源数据有空箱子，就要移除当前数据的空箱子
        if (hasEmptyBox && !data.containerNo && !data.soNo) {
          if (!data.uuid) {
            continue
          }
          data.deleted = true
        }
        oldMap[data.containerNo + '#' + data.soNo] = data
        newManifestGoodsInfos.push(data)
      }
    }
    for (const item of containerUsages) {
      // 如果是已存在的数据，则更新数据，如果是不存在的数据，则新增数据
      const soNo = job.masterFlag ? item.soNo : job.soNo
      const containerNo = item.container.containerNo
      const isEmptyKey = !containerNo && !soNo
      const key = containerNo + '#' + soNo
      // 如果没有箱号和关单号，不更新数据，直接新增数据
      if (!isEmptyKey && oldMap.hasOwnProperty(key)) {
        const updateData = oldMap[key]
        await this.syncGoodsInfo(updateData, item, job, manifestInfo, isSeaHouseChannel, newManifestGoodsInfos, ediPkList, ediEqList)
        continue
      }
      const manifestGoodsInfo = new ManifestGoodsInfo().fillDefaultValue().getData()
      await this.syncGoodsInfo(manifestGoodsInfo, item, job, manifestInfo, isSeaHouseChannel, newManifestGoodsInfos, ediPkList, ediEqList)
      newManifestGoodsInfos.push(manifestGoodsInfo)
      oldMap[manifestGoodsInfo.containerNo + '#' + manifestGoodsInfo.soNo] = manifestGoodsInfo
    }
    manifestInfo.manifestGoods = newManifestGoodsInfos
    return newManifestGoodsInfos
  }

  /**
   *
   * @param containerUsages
   * @param rowData
   * @param job
   * @param manifestInfo
   * @param poItems
   * @returns {[]}
   */
  static async syncPoItems(containerUsages, rowData, job, manifestInfo, poItems, ediPkList = [], ediEqList = []) {
    const newManifestGoodsInfos = []
    const oldMap = {}
    if (rowData && rowData.length > 0) {
      for (const data of rowData) {
        // 来源数据有空箱子，就要移除当前数据的空箱子
        if (!data.soNo || !data.soNo.trim()) {
          if (!data.uuid) {
            continue
          }
          data.deleted = true
        }
        oldMap[data.soNo + ' ' + data.containerNo] = data
        newManifestGoodsInfos.push(data)
      }
    }
    for (const item of containerUsages) {
      const poItemList = poItems.filter(p => p.containerUsageKey === item.uuid)
      // 箱子下没有货物信息的情况，直接以箱子为维度生成一条记录
      if (!poItemList || !(poItemList.length > 0)) {
        const manifestGoodsInfo = new ManifestGoodsInfo().fillDefaultValue().getData()
        await this.syncGoodsInfo(manifestGoodsInfo, item, job, manifestInfo, true, newManifestGoodsInfos, ediPkList, ediEqList)
        newManifestGoodsInfos.push(manifestGoodsInfo)
        oldMap[manifestGoodsInfo.soNo] = manifestGoodsInfo
      }
      for (const poItem of poItemList) {
        // 如果是已存在的数据，则更新数据，如果是不存在的数据，则新增数据
        const key = poItem.soNo + ' ' + item.container.containerNo
        if (poItem.soNo && oldMap.hasOwnProperty(key) && !oldMap[key].deleted) {
          const updateData = oldMap[key]
          await this.syncPoGoodsInfo(updateData, item, job, manifestInfo, poItem, newManifestGoodsInfos, ediPkList, ediEqList)
          continue
        }
        const manifestGoodsInfo = new ManifestGoodsInfo().fillDefaultValue().getData()
        await this.syncPoGoodsInfo(manifestGoodsInfo, item, job, manifestInfo, poItem, newManifestGoodsInfos, ediPkList, ediEqList)
        newManifestGoodsInfos.push(manifestGoodsInfo)
        oldMap[manifestGoodsInfo.soNo] = manifestGoodsInfo
      }
    }
    manifestInfo.manifestGoods = newManifestGoodsInfos
    return newManifestGoodsInfos
  }
  static async syncGoodsInfo(manifestGoodsInfo, item, job, manifestInfo, isSeaHouseChannel, newManifestGoodsInfos, ediPkList = [], ediEqList = []) {
    manifestGoodsInfo.eqSize = item.container.eqSize + item.container.eqType
    manifestGoodsInfo.containerNo = item.container.containerNo
    manifestGoodsInfo.sealNo = item.container.sealNo
    manifestGoodsInfo.cargoEnglishName = item.cargoName
    manifestGoodsInfo.mark = item.mark
    manifestGoodsInfo.quantity = item.quantity
    manifestGoodsInfo.weight = item.weight
    manifestGoodsInfo.cubage = item.cubage
    manifestGoodsInfo.jobUuid = item.jobUuid

    manifestGoodsInfo.hsCode = item.hsCode
    manifestGoodsInfo.soNo = job.masterFlag ? item.soNo : job.soNo
    if (isSeaHouseChannel) {
      const seaHouse = await ThirdPartyMappingUtil.getInstance('seaHouse')
      const packageList = seaHouse.getListByDataType('packing')
      const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', job.packing)
      manifestGoodsInfo.packing = !packing ? '' : ThirdPartyMappingUtil.getPackageCode(packageList, packing.name)
      if (!job.masterFlag) {
        manifestGoodsInfo.soNo = ''
      }
    } else if (ediPkList && ediPkList.length > 0) {
      const ediPk = ediPkList.find(item => item.sourceValue === job.packing)
      if (ediPk) {
        manifestGoodsInfo.packing = ediPk.targetValue
      } else {
        manifestGoodsInfo.packing = item.packing
      }
    } else {
      manifestGoodsInfo.packing = item.packing
    }
    if (ediEqList && ediEqList.length > 0) {
      const ediEq = ediEqList.find(item => item.sourceValue === item.container.eqSize)
      if (ediEq) {
        manifestGoodsInfo.eqSize = ediEq.targetValue
      }
    }

    manifestGoodsInfo.soc = item.soc ? 1 : 0
    manifestGoodsInfo.manifestInfoUuid = manifestInfo.uuid
    manifestGoodsInfo.serialNumber = PrePlanBookingUtil.getMaxSerialNumber(null, newManifestGoodsInfos)
  }

  static async syncPoGoodsInfo(manifestGoodsInfo, item, job, manifestInfo, poItem, newManifestGoodsInfos, ediPkList = [], ediEqList = []) {
    manifestGoodsInfo.eqSize = item.container.eqSize + item.container.eqType
    manifestGoodsInfo.containerNo = item.container.containerNo
    manifestGoodsInfo.sealNo = item.container.sealNo
    manifestGoodsInfo.cargoEnglishName = poItem.englishCommodity
    manifestGoodsInfo.mark = poItem.mark
    manifestGoodsInfo.quantity = poItem.quantity
    manifestGoodsInfo.weight = poItem.grossWeight
    manifestGoodsInfo.cubage = poItem.cubage
    manifestGoodsInfo.jobUuid = poItem.jobUuid
    manifestGoodsInfo.hsCode = poItem.hsCode
    manifestGoodsInfo.soNo = (poItem.soNo + ' ' + item.container.containerNo).trim() ? poItem.soNo : ''
    if (ediPkList && ediPkList.length > 0) {
      const ediPk = ediPkList.find(item => item.sourceValue === poItem.packing)
      if (ediPk) {
        manifestGoodsInfo.packing = ediPk.targetValue
      } else {
        manifestGoodsInfo.packing = job.packing
      }
    } else {
      const seaHouse = await ThirdPartyMappingUtil.getInstance('seaHouse')
      const packageList = seaHouse.getListByDataType('packing')
      const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', poItem.packing)
      manifestGoodsInfo.packing = !packing ? '' : ThirdPartyMappingUtil.getPackageCode(packageList, packing.name)
    }
    if (ediEqList && ediEqList.length > 0) {
      const ediEq = ediEqList.find(item => item.sourceValue === item.container.eqSize)
      if (ediEq) {
        manifestGoodsInfo.eqSize = ediEq.targetValue
      }
    }
    manifestGoodsInfo.soc = item.soc ? 1 : 0
    manifestGoodsInfo.manifestInfoUuid = manifestInfo.uuid
    manifestGoodsInfo.serialNumber = PrePlanBookingUtil.getMaxSerialNumber(null, newManifestGoodsInfos)
  }

  /**
   * 同步基本信息数据
   * @param manifestInfo
   * @param job
   */
  static async newCreateSyncWithJob(manifestInfo, job, btn = false, newCargoDoc = [], channel = null) {
    const isSent = this.isSent(manifestInfo)
    if (isSent) { // 已发送的不接受同步
      return
    }
    manifestInfo.jobUuid = job.uuid
    if (job.loadingPortCode) {
      manifestInfo.portOfLoading = job.loadingPortCode
    }
    if (job.dischargingPortCode) {
      manifestInfo.portOfDischarge = job.dischargingPortCode
    }
    if (channel === WSE_CHANNEL.code && job.transfering) {
      if (job.transferPortCode) {
        manifestInfo.portOfDischarge = job.transferPortCode
      }
    }
    if (job.destinationPortCode) {
      manifestInfo.portOfDestination = job.destinationPortCode
    }
    manifestInfo.sailingDate = job.etd
    manifestInfo.mblNo = job.mbl
    manifestInfo.bargeVessel = job.vessel
    manifestInfo.bargeVoyage = job.voyageFlight
    manifestInfo.dispatchingPlaceCode = job.dispatchingPlaceCode
    manifestInfo.carrierAgent = job.carrierAgentId
    manifestInfo.shippingCompany = job.carrierId
    manifestInfo.cargoType = job.cargoType
    manifestInfo.masterBLFreightTermTootip = job.freightTerm
    manifestInfo.masterBLFreightTerm = job.paymentTermMBL
    manifestInfo.shipperCountryCode = 'CN'
    manifestInfo.imo = job.vesselIMO
    const mbl = await new SeaExportJob(job).getMainMbl()
    if (job.signMBL || mbl) {
      if (mbl) {
        this.setManifestInfoData(manifestInfo, mbl, btn)
      } else if (newCargoDoc && newCargoDoc.length > 0) {
        for (const doc of newCargoDoc) {
          if (doc.docType === 'MBL') {
            this.setManifestInfoData(manifestInfo, doc, btn)
            break
          }
        }
      }
    }
    if (channel === WSE_CHANNEL.code) {
      await this.syncWseInfo(manifestInfo, job)
    } else if (channel === RONGE_TONG_CHANNEL.code) {
      await this.syncRongeTongInfo(manifestInfo, job)
    } else {
      this.syncSeaHouseInfo(manifestInfo, job)
    }
  }

  /**
   * 原始单为回执错误，退单，删除单为回执成功时可以修改所有字段，否则只可以更改部分字段]
   * @param manifestInfo
   * @returns {boolean|boolean}
   */
  static isSent(manifestInfo) {
    const canUpdateStates = ['22', '23', '61']
    return !!manifestInfo.seaHouseState && manifestInfo.seaHouseState !== '-1' && !(canUpdateStates.indexOf(manifestInfo.seaHouseState) > -1)
  }

  static setManifestInfoData(manifestInfo, mbl, btn) {
    manifestInfo.placeOfPayment = mbl.paymentPlaceBL
    manifestInfo.signPlaceBL = mbl.signPlaceBL
    manifestInfo.signDateBL = mbl.signDateBL
    manifestInfo.blType = mbl.releaseType + ''
    manifestInfo.blNumber = mbl.blNumber
    const thirdPartyBlType = this.syncBlType(mbl.releaseType + '')
    if (thirdPartyBlType) {
      manifestInfo.thirdPartyBlType = thirdPartyBlType
    }
  }

  /**
   * 同步海管家基本信息，无数据时不同步
   * @param manifestInfo
   * @param job
   * @param mbl
   */
  static syncSeaHouseInfo(manifestInfo, job) {
    const allCompany = getCacheListByKey(basicCacheKeys.basic_data_Company)
    const carriers = allCompany.filter(p => p.cmpIdx === Number(job.carrierId))
    if (carriers && carriers.length > 0) {
      const carrier = this.getSeaHouseShipCompanyCode(carriers[0])
      if (carrier) {
        manifestInfo.thirdPartyCarrier = carrier
      }
    }
    const carrierAgents = allCompany.filter(p => p.cmpIdx === Number(job.carrierAgentId))
    if (carrierAgents && carrierAgents.length > 0) {
      const carrierAgent = this.getSeaHouseShipCompanyAgentCode(carrierAgents[0])
      if (carrierAgent) {
        manifestInfo.thirdPartyCarrierAgent = carrierAgent
      }
    }
    if (this.isExists(job.cargoType, SEA_HOUSE_CARGO_TYPE)) {
      manifestInfo.thirdPartyCargoType = job.cargoType
    }
    // 通道为海管家时，不同步运输条款
    // if (this.isExists(job.freightTerm, SEA_HOUSE_FREIGHT_TERM)) {
    //   manifestInfo.thirdPartyFreightTerm = job.freightTerm
    // }
    const thirdPartyPaymentMethod = this.syncPaymentMethod(job.paymentTermMBL)
    if (thirdPartyPaymentMethod) {
      manifestInfo.thirdPartyPaymentMethod = thirdPartyPaymentMethod
    }
  }
  // 未斯舱单同步基本信息
  static async syncWseInfo(manifestInfo, job) {
    const ifSh = job.loadingPortCode === 'CNSHA'
    const filterValue = ifSh ? 'sh' : 'qd'
    const thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
    const carrierCompanyList = thirdPartyMappingUtil.getListByDataType('carrier').filter(t => t.filterValue === filterValue)
    const allCompany = getCacheListByKey(basicCacheKeys.basic_data_Company)
    const carrierCompanies = allCompany.filter(p => p.cmpIdx === Number(job.carrierId))
    // 船公司
    if (carrierCompanies && carrierCompanies.length > 0) {
      const carrier = carrierCompanies[0]
      if (carrier) {
        const englishName = carrier.englishName
        const chineseName = carrier.chineseName
        const shortName = carrier.shortName
        const cnShortName = carrier.cnShortName
        for (const item of carrierCompanyList) {
          const wsCode = item.code
          const wsChineseName = item.chineseName
          if (wsCode === englishName || wsCode === chineseName || wsCode === shortName || wsCode === cnShortName || wsChineseName === englishName || wsChineseName === chineseName || wsChineseName === shortName || wsChineseName === cnShortName) {
            manifestInfo.thirdPartyCarrier = item.code
            break
          }
        }
      }
    }
    // 船代
    const carrierAgentCompanyList = thirdPartyMappingUtil.getListByDataType('carrierAgent').filter(t => t.filterValue === filterValue)
    const carrierAgents = allCompany.filter(p => p.cmpIdx === Number(job.carrierAgentId))
    if (carrierAgents && carrierAgents.length > 0) {
      const carrier = carrierAgents[0]
      if (carrier) {
        for (const item of carrierAgentCompanyList) {
          if (item.chineseName === carrier.chineseName) {
            manifestInfo.thirdPartyCarrierAgent = item.code
            break
          }
        }
      }
    }
    // 货物类型
    const allCargoType = getCacheListByKey(basicCacheKeys.basic_data_CargoType)
    const cargoTypes = allCargoType.filter(p => p.code === Number(job.cargoType))
    if (cargoTypes && cargoTypes.length > 0) {
      const cargoType = cargoTypes[0]
      if (cargoType) {
        const generalCargoList = ['General Cargo', '普货']
        if (generalCargoList.includes(cargoType.chineseName) || generalCargoList.includes(cargoType.englishName)) {
          manifestInfo.thirdPartyCargoType = 'S'
        }
      }
    }
  }
  // 荣e通 特殊同步逻辑
  static async syncRongeTongInfo(manifestInfo, job) {
    const ifSh = manifestInfo.portOfLoading === 'CNSHA'
    const filterValue = ifSh ? 'sh' : 'qd'
    const thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
    const carrierCompanyList = thirdPartyMappingUtil.getListByDataType('carrier').filter(t => t.filterValue === filterValue)
    const allCompany = getCacheListByKey(basicCacheKeys.basic_data_Company)
    const allpaymentTermList = getCacheListByKey(basicCacheKeys.basic_data_PaymentTerm)
    const paymentTermList = allpaymentTermList.filter(p => p.code === job.paymentTermMBL)
    const carrierCompanies = allCompany.filter(p => p.cmpIdx === Number(job.carrierId))
    // 船公司
    if (carrierCompanies && carrierCompanies.length > 0) {
      const carrier = carrierCompanies[0]
      if (carrier) {
        const englishName = carrier.englishName
        const chineseName = carrier.chineseName
        const shortName = carrier.shortName
        const cnShortName = carrier.cnShortName
        for (const item of carrierCompanyList) {
          const wsCode = item.code
          const wsChineseName = item.chineseName
          if (wsCode === englishName || wsCode === chineseName || wsCode === shortName || wsCode === cnShortName || wsChineseName === englishName || wsChineseName === chineseName || wsChineseName === shortName || wsChineseName === cnShortName) {
            manifestInfo.thirdPartyCarrier = item.code
            break
          }
        }
      }
    }
    // 货物类型
    if (job.cargoType === 'GC') {
      manifestInfo.thirdPartyCargoType = '普通货物'
    } else if (job.cargoType === 'DG') {
      manifestInfo.thirdPartyCargoType = '危险品'
    } else {
      manifestInfo.cargoType = ''
    }
    // 提单件数
    if (manifestInfo.blNumber === 'ONE') {
      manifestInfo.blNumber = '1'
    } else if (manifestInfo.blNumber === 'TWO') {
      manifestInfo.blNumber = '2'
    } else {
      manifestInfo.blNumber = '3'
    }
    // 提单类型
    if (manifestInfo.blType === '1') {
      manifestInfo.thirdPartyBlType = 'OBL-正本提单'
    } else if (manifestInfo.blType === '2') {
      manifestInfo.thirdPartyBlType = 'TER-电放'
    } else if (manifestInfo.blType === '3') {
      manifestInfo.thirdPartyBlType = 'SWB-海运单'
    } else {
      manifestInfo.thirdPartyBlType = ''
    }
    // 主单运费条款
    if (paymentTermList && paymentTermList.length > 0) {
      const paymentTerm = paymentTermList[0]
      if (paymentTerm) {
        if (paymentTerm.name === 'FREIGHT PREPAID') {
          manifestInfo.thirdPartyPaymentMethod = '预付'
        } else if (paymentTerm.name === 'FREIGHT COLLECT') {
          manifestInfo.thirdPartyPaymentMethod = '到付'
        } else {
          manifestInfo.thirdPartyPaymentMethod = ''
        }
      }
    }
  }
  static syncBlType(releaseType) {
    if (releaseType === '1') {
      return 'OBL'
    }
    if (releaseType === '2') {
      return 'TER'
    }
    if (releaseType === '3') {
      return 'SWB'
    }
    return ''
  }
  static syncPaymentMethod(paymentTermMBL) {
    if (paymentTermMBL === 'PP') {
      return 'P'
    }
    if (paymentTermMBL === 'CC') {
      return 'C'
    }
    if (paymentTermMBL === 'FPD' || paymentTermMBL === 'FPH' || paymentTermMBL === 'FPD/FPH') {
      return 'E'
    }
    return ''
  }

  /**
   * 检验舱单soNo
   * @param manifestInfo
   * @param job
   * @param view
   * @returns {Promise<boolean>}
   */
  static async checkPrePlanBookingSoNo(manifestInfo, job, view) {
    let checkSoNo = false
    if (PrePlanBookingUtil.checkSoNo(manifestInfo, job)) {
      await view.$confirm(lang.t('CargoMsg.Cargo_PrePlanBookingCheckSoNo'), lang.t('common.tips.prompt'), {
        confirmButtonText: lang.t('SeaExport.Yes'),
        cancelButtonText: lang.t('SeaExport.No'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
      }).catch(() => {
        checkSoNo = true
      })
    }
    return checkSoNo
  }
  /**
   * 判断装箱信息的关单号是否存在业务中
   * @param manifestInfo
   * @param job
   * @returns {boolean}
   */
  static checkSoNo(manifestInfo, job) {
    const goodsInfos = manifestInfo.manifestGoods
    if (!goodsInfos && goodsInfos.length === 0) {
      return false
    }
    const jobSoNos = []
    // 如果是主票
    const soNoMap = {}
    if (job.mbl) {
      jobSoNos.push(...job.mbl.split('\n'))
    }
    if (job.soNo) {
      jobSoNos.push(...job.soNo.split('\n'))
    }
    if (job.masterFlag) {
      // 获取小票
      const lclSlavesList = job.lclSlaves
      if (lclSlavesList.length > 0) {
        lclSlavesList.forEach(element => {
          const soNo = element.soNo
          if (soNo) {
            jobSoNos.push(...soNo.split('\n'))
          }
        })
      }
    }
    if (jobSoNos && jobSoNos.length > 0) {
      for (const jobSoNo of jobSoNos) {
        if (jobSoNo) {
          soNoMap[jobSoNo.toUpperCase()] = true
        }
      }
    }
    for (const goodsInfo of goodsInfos) {
      if (!soNoMap.hasOwnProperty(goodsInfo.soNo.toUpperCase())) {
        return true
      }
    }
    return false
  }

  /**
   * 提单方式转换，mbl 转 预配
   * @param value
   * @param sourceField
   * @param targetField
   * @returns {string|*}
   */
  static getBillTypeBySerialNumber(value, sourceField, targetField) {
    const blModeList = this.getBlModelList()
    if (blModeList && blModeList.length > 0) {
      for (const blMode of blModeList) {
        if (blMode[sourceField] === value + '') {
          return blMode[targetField]
        }
      }
    }
    return ''
  }

  /**
   * 获取 提单方式
   * @returns {[{localName: string | VueI18n.LocaleMessageArray, serialNumber: string, code: string, name: string}, {localName: string | VueI18n.LocaleMessageArray, serialNumber: string, code: string, name: string}, {localName: string | VueI18n.LocaleMessageArray, serialNumber: string, code: string, name: string}]}
   */
  static getBlModelList() {
    const blModeList = [
      { serialNumber: '1', code: 'ORIGINAL', name: 'ORIGINAL', localName: lang.t('SeaExport.OriginalNormal') },
      { serialNumber: '2', code: 'SURRENDERED', name: 'SURRENDERED', localName: lang.t('SeaExport.TelexRelease') },
      { serialNumber: '3', code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: lang.t('SeaExport.TelexRelease') }
    ]
    const blModeListCache = getCacheListByKey(basicCacheKeys.basic_data_BlMode)
    if (blModeListCache && blModeListCache.length > 0) {
      for (const blMode of blModeListCache) {
        if (blMode.blType === 1) {
          blModeList.push({ serialNumber: String(blMode.serialNumber), code: blMode.localName, name: blMode.localName, localName: blMode.localName })
        }
      }
    }
    return blModeList
  }
  // 发送、更正时校验
  static async validation(manifestInfo, job, whole) {
    // MB/L
    const field = {
      name: [],
      tabName: [],
      tabField: []
    }
    if (manifestInfo.mblNo !== job.mbl) {
      field.name.push('MB/L NO')
      field.tabName.push(lang.t('SeaExport.Booking'))
      field.tabField.push('MB/L No.')
    }

    // 船名
    if (manifestInfo.bargeVessel !== job.vessel) {
      field.name.push(lang.t('SeaExport.Vessel'))
      field.tabName.push(lang.t('SeaExport.Booking'))
      field.tabField.push(lang.t('SeaExport.Vessel'))
    }

    // 航次
    if (manifestInfo.bargeVoyage !== job.voyageFlight) {
      field.name.push(lang.t('SeaExport.Voyage'))
      field.tabName.push(lang.t('SeaExport.Booking'))
      field.tabField.push(lang.t('SeaExport.Voyage'))
    }

    // 船公司
    if (manifestInfo.shippingCompany !== job.carrierId) {
      field.name.push(lang.t('SeaExport.ShippingCompany'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.ShippingCompany'))
    }

    // 起运港
    if (manifestInfo.portOfLoading !== job.loadingPortCode) {
      field.name.push(lang.t('SeaExport.PortOfLoadingAI'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.PortOfLoading'))
    }

    // 卸货港
    if (manifestInfo.portOfDischarge !== job.dischargingPortCode) {
      field.name.push(lang.t('SeaExport.dischargingPort'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.PortOfDischarge'))
    }

    // 目的港or交货地
    if (manifestInfo.portOfDestination !== job.destinationPortCode) {
      field.name.push(lang.t('SeaExport.PortOfDestination'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.PlaceOfDelivery'))
    }

    // 运输条款/主单运输条款
    if (manifestInfo.masterBLFreightTermTootip !== job.freightTerm) {
      field.name.push(lang.t('SeaExport.TransportationClause'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.MBLTransportationClause'))
    }
    // ==========================================================================
    // 船代
    if (manifestInfo.carrierAgent !== job.carrierAgentId) {
      field.name.push(lang.t('SeaExport.CarrierAgent'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.CarrierAgent'))
    }

    // 主单运费条款
    if (manifestInfo.masterBLFreightTerm !== job.paymentTermMBL) {
      field.name.push(lang.t('SeaExport.FreightTerm'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.MasterBLFreightTerm'))
    }

    const jobMbl = await new SeaExportJob(job).getMainMbl()
    const mbl = jobMbl || {} // 防止空对象引用异常
    // 主单付款地点
    if (manifestInfo.placeOfPayment !== mbl.paymentPlaceBL) {
      field.name.push(lang.t('SeaExport.PlaceOfPayment'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.PlaceOfMblPayment'))
    }

    // 开航日期
    if (manifestInfo.sailingDate !== job.etd) {
      field.name.push(lang.t('SeaExport.DateOfDeparture'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.DateOfDeparture2'))
    }

    // 发货地(代码)
    // whole整箱时才验证发货地，拼箱不验证
    if (manifestInfo.dispatchingPlaceCode !== job.dispatchingPlaceCode && whole) {
      field.name.push(lang.t('SeaExport.PlaceOfReceipt'))
      field.tabName.push(lang.t('SeaExport.Basic'))
      field.tabField.push(lang.t('SeaExport.PlaceOfReceiptCodeOnBl'))
    }

    // 提单方式
    if (manifestInfo.blType !== mbl.releaseType + '') {
      field.name.push(lang.t('SeaExport.BlType'))
      field.tabName.push('MB/L')
      field.tabField.push(lang.t('SeaExport.BlType'))
    }

    // 签发地点
    if (manifestInfo.signPlaceBL !== mbl.signPlaceBL) {
      field.name.push(lang.t('SeaExport.PlaceOfIssue'))
      field.tabName.push('MB/L')
      field.tabField.push(lang.t('SeaExport.PlaceOfIssue'))
    }

    // 签发日期
    if (manifestInfo.signDateBL !== mbl.signDateBL) {
      field.name.push(lang.t('SeaExport.DateOfIssue'))
      field.tabName.push('MB/L')
      field.tabField.push(lang.t('SeaExport.DateOfIssue'))
    }

    // 提单份数
    if (manifestInfo.blNumber !== mbl.blNumber) {
      field.name.push(lang.t('SeaExport.NoOfOriginalBls'))
      field.tabName.push('MB/L')
      field.tabField.push(lang.t('SeaExport.NoOfOriginalBls'))
    }

    const fieldString = {
      name: field.name.join('、'),
      tabName: Array.from(new Set(field.tabName)).join('、'),
      tabField: field.tabField.join('、')
    }
    return fieldString
  }

  /**
   * 处理预配平台导入、包含CW、海管家
   * @param response
   * @param view
   */
  static saveImportData(response, view) {
    if (response && response.code === '0' && response.data) {
      view.importData(response.data)
    } else if (response && response.code === '5604011' && response.data) {
      if (response.message) {
        view.$message.warning(response.message)
      }
      view.importData(response.data)
    }
    if (response && response.code === '5604018') {
      view.$confirm(response.message, lang.t('Message.Error2'), {
        dangerouslyUseHTMLString: true,
        showClose: false,
        confirmButtonText: lang.t('CargoMsg.Cargo_PartialImport'),
        cancelButtonText: lang.t('common.btn.close'),
        type: 'error'
      }).then(() => {
        view.importData(response.data)
        // 定位到该列
      }).catch(() => {
      })
    } else if (response && response.code === '5604019') {
      view.$message.warning(response.message)
    } else {
      if (response && response.errors && response.errors.length > 0 && response.errors[0].message) {
        view.$message.warning(lang.t(response.errors[0].message))
      } else {
        view.$message.success(lang.t('Message.ImportSuccessful1'))
      }
    }
  }

  /**
   * 同步客运收发通
   * @param manifestInfo
   * @param item
   */
  static syncCustomerShippingInformation(manifestInfo, item, syncKeys) {
    /* 发货人 */
    if (!syncKeys || syncKeys.indexOf('shipper') >= 0) {
      manifestInfo.shipperShortCode = item.shipperShortCode
      manifestInfo.shipperEnterpriseCode = item.shipperEnterpriseCode
      manifestInfo.shipperEnterpriseName = item.shipperEnterpriseName
      manifestInfo.shipperAddress = item.shipperAddress
      manifestInfo.shipperContactsType = item.shipperContactsType
      manifestInfo.shipperContacts = item.shipperContacts
      manifestInfo.shipperCityName = item.shipperCityName
      manifestInfo.shipperProvinceCode = item.shipperProvinceCode
      manifestInfo.shipperProvinceName = item.shipperProvinceName
      manifestInfo.shipperZipCode = item.shipperZipCode
      manifestInfo.shipperCountryCode = item.shipperCountryCode
      manifestInfo.shipperAeoEnterpriseCode = item.shipperAeoEnterpriseCode
      manifestInfo.instructBill = item.instructBill
    }

    /* 收货人 */
    if (!syncKeys || syncKeys.indexOf('consignee') >= 0) {
      manifestInfo.consigneeShortCode = item.consigneeShortCode
      manifestInfo.consigneeEnterpriseCode = item.consigneeEnterpriseCode
      manifestInfo.consigneeEnterpriseName = item.consigneeEnterpriseName
      manifestInfo.consigneeAddress = item.consigneeAddress
      manifestInfo.consigneeContactsType = item.consigneeContactsType
      manifestInfo.consigneeContacts = item.consigneeContacts
      manifestInfo.consigneeCityName = item.consigneeCityName
      manifestInfo.consigneeProvinceCode = item.consigneeProvinceCode
      manifestInfo.consigneeProvinceName = item.consigneeProvinceName
      manifestInfo.consigneeZipCode = item.consigneeZipCode
      manifestInfo.consigneeCountryCode = item.consigneeCountryCode
      manifestInfo.consigneeAeoEnterpriseCode = item.consigneeAeoEnterpriseCode
      manifestInfo.consigneeSpecificContactsName = item.consigneeSpecificContactsName
      manifestInfo.consigneeSpecificContactsType = item.consigneeSpecificContactsType
      manifestInfo.consigneeSpecificContacts = item.consigneeSpecificContacts
    }

    /* 通知人 */
    if (!syncKeys || syncKeys.indexOf('notify') >= 0) {
      manifestInfo.notifyShortCode = item.notifyShortCode
      manifestInfo.notifyEnterpriseCode = item.notifyEnterpriseCode
      manifestInfo.notifyEnterpriseName = item.notifyEnterpriseName
      manifestInfo.notifyAddress = item.notifyAddress
      manifestInfo.notifyContactsType = item.notifyContactsType
      manifestInfo.notifyContacts = item.notifyContacts
      manifestInfo.notifyCityName = item.notifyCityName
      manifestInfo.notifyProvinceCode = item.notifyProvinceCode
      manifestInfo.notifyProvinceName = item.notifyProvinceName
      manifestInfo.notifyZipCode = item.notifyZipCode
      manifestInfo.notifyCountryCode = item.notifyCountryCode
      manifestInfo.notifyAeoEnterpriseCode = item.notifyAeoEnterpriseCode
    }
  }

  /**
   * 查看海管家船代
   * @param thirdPartyCarrier
   * @param bargeVessel
   * @param bargeVoyage
   * @returns {Promise<*>}
   */
  static async getSeaHouseShipCompanyAgentByApi(thirdPartyCarrier, bargeVessel, bargeVoyage) {
    const params = {
      shipCompany: thirdPartyCarrier,
      vessel: bargeVessel,
      voyNo: bargeVoyage
    }
    const value = await getShipAgent(params).then(res => res.data)
    return value || lang.t('CargoMsg.Cargo_PleaseInquireWithTheBookingHatchOrCustomerService')
  }

  /**
   * 查看未斯船代
   * @param thirdPartyCarrier
   * @param bargeVessel
   * @param bargeVoyage
   * @returns {Promise<*>}
   */
  static async getWseShipCompanyAgentByApi(thirdPartyCarrier, bargeVessel, bargeVoyage) {
    const params = {
      shipCompany: thirdPartyCarrier,
      vessel: bargeVessel,
      voyNo: bargeVoyage
    }
    const value = await getWseShipAgent(params).then(res => res.data)
    return value || lang.t('CargoMsg.Cargo_PleaseInquireWithTheBookingHatchOrCustomerService')
  }
  static async getRongeTongShipCompanyAgentByApi(portOfLoading, thirdPartyCarrier, bargeVessel, bargeVoyage, mblNo) {
    const params = {
      portOfLoading: portOfLoading,
      shipCompany: thirdPartyCarrier,
      vessel: bargeVessel,
      voyNo: bargeVoyage,
      masterBillNo: mblNo
    }
    const value = await getRongeTongShipAgent(params).then(res => res.data)
    return value || lang.t('CargoMsg.Cargo_PleaseInquireWithTheBookingHatchOrCustomerService')
  }

  /**
   * 获取货物信息最大序号
   * @returns {number}
   */
  static getMaxSerialNumber(manifestInfo, newManifestGoodsInfos) {
    let max = 0
    let manifestGoods = newManifestGoodsInfos || []
    if (manifestInfo && manifestInfo.manifestGoods && manifestInfo.manifestGoods.length > 0) {
      manifestGoods = manifestInfo.manifestGoods
    }
    if (manifestGoods && manifestGoods.length > 0) {
      for (const c of manifestGoods) {
        if (c.serialNumber > max) {
          max = c.serialNumber
        }
      }
    }
    return max + 1
  }

  /**
   * 荣亿通发送舱单的校验逻辑
   */
  static rongeTongSendCheck(manifestInfo, manifestGoods, view) {
    const ifSh = manifestInfo.portOfLoading === 'CNSHA'
    const checkList = []
    // MB/L NO校验
    if (!manifestInfo.mblNo) {
      checkList.push({ field: 'MB/L NO', errorDescription: view.$t('SeaExport.Required') })
    } else {
      // 校验输入大写字符和数字，长度限制在6-30个
      const mblNoRegex = /^[A-Z0-9]{6,30}$/
      if (!mblNoRegex.test(manifestInfo.mblNo)) {
        checkList.push({ field: 'MB/L NO', errorDescription: '必须为6-30位大写字符和数字' })
      }
    }
    // 船公司校验
    if (!manifestInfo.thirdPartyCarrier) {
      checkList.push({ field: view.$t('SeaExport.ShippingCompany'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 货物类型校验
    if (!manifestInfo.thirdPartyCargoType) {
      checkList.push({ field: view.$t('SeaExport.CargoType'), errorDescription: view.$t('SeaExport.Required') })
    }

    // 提单方式校验
    if (!manifestInfo.thirdPartyBlType) {
      checkList.push({ field: view.$t('SeaExport.BlType'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 提单份数校验
    if (!manifestInfo.blNumber) {
      checkList.push({ field: view.$t('SeaExport.NoOfOriginalBls'), errorDescription: view.$t('SeaExport.Required') })
    } else {
      // 只允许数字
      const blNumberRegex = /^\d+$/
      if (!blNumberRegex.test(manifestInfo.blNumber)) {
        checkList.push({ field: view.$t('SeaExport.NoOfOriginalBls'), errorDescription: view.$t('Message.BlNumberRegex') })
      }
    }
    // 运费条款校验
    if (!manifestInfo.thirdPartyPaymentMethod) {
      checkList.push({ field: view.$t('SeaExport.FreightTerm'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 船名校验
    if (!manifestInfo.bargeVessel) {
      checkList.push({ field: view.$t('SeaExport.Vessel'), errorDescription: view.$t('SeaExport.Required') })
    } else {
      // 校验是否包含中文或全角字符
      const fullWidthRegex = /[\uFF00-\uFFEF\u4E00-\u9FA5\u3000-\u303F]/
      if (fullWidthRegex.test(manifestInfo.bargeVessel)) {
        checkList.push({ field: view.$t('SeaExport.Vessel'), errorDescription: view.$t('CargoMsg.Cargo_VesselTip2') // 你可以换个提示，比如“不能包含中文或全角字符”
        })
      }
      // 校验输入大小写字符和数字，不能超过35长度
      if (manifestInfo.bargeVessel.length > 35) {
        checkList.push({ field: view.$t('SeaExport.Vessel'), errorDescription: view.$t('SeaExport.maxLength', ['35']) })
      }
    }
    // 航次校验
    if (!manifestInfo.bargeVoyage) {
      checkList.push({ field: view.$t('SeaExport.Voyage'), errorDescription: view.$t('SeaExport.Required') })
    } else {
      // 不能超过20长度
      if (manifestInfo.bargeVoyage.length > 20) {
        checkList.push({ field: view.$t('SeaExport.Voyage'), errorDescription: view.$t('SeaExport.maxLength', ['20']) })
      }
    }
    // 船代校验
    if (!manifestInfo.thirdPartyCarrierAgent) {
      checkList.push({ field: view.$t('SeaExport.CarrierAgent'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 发货地校验
    if (!manifestInfo.dispatchingPlaceCode) {
      checkList.push({ field: view.$t('SeaExport.PlaceOfReceipt'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 起运港校验
    if (!manifestInfo.portOfLoading) {
      checkList.push({ field: view.$t('SeaExport.PortOfLoadingAI'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 卸货港校验
    if (!manifestInfo.portOfDischarge) {
      checkList.push({ field: view.$t('SeaExport.dischargingPort'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 收发通信息校验
    // 收货人名称
    if (!manifestInfo.consigneeEnterpriseName) {
      checkList.push({ field: view.$t('SeaExport.consigneeName'), errorDescription: view.$t('SeaExport.Required') })
    } else if (manifestInfo.consigneeEnterpriseName.length > 140) {
      checkList.push({ field: view.$t('SeaExport.consigneeName'), errorDescription: view.$t('SeaExport.maxLength', ['140']) })
    }
    // 收货人地址
    if (!manifestInfo.consigneeAddress) {
      checkList.push({ field: view.$t('SeaExport.consigneeDetailAddress'), errorDescription: view.$t('SeaExport.Required') })
    } else if (manifestInfo.consigneeAddress.length > 140) {
      checkList.push({ field: view.$t('SeaExport.consigneeDetailAddress'), errorDescription: view.$t('SeaExport.maxLength', ['140']) })
    }
    // 收货人国家
    if (!manifestInfo.consigneeCountryCode) {
      checkList.push({ field: view.$t('SeaExport.ActualRecipientCountry'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 收货人电话
    if (manifestInfo.consigneeContactsType !== 0 || !manifestInfo.consigneeContacts) {
      checkList.push({ field: view.$t('SeaExport.consigneePhone'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 发货人名称
    if (!manifestInfo.shipperEnterpriseName) {
      checkList.push({ field: view.$t('SeaExport.consignorName'), errorDescription: view.$t('SeaExport.Required') })
    } else if (manifestInfo.shipperEnterpriseName.length > 140) {
      checkList.push({ field: view.$t('SeaExport.consignorName'), errorDescription: view.$t('SeaExport.maxLength', ['140']) })
    }
    // 发货人地址
    if (!manifestInfo.shipperAddress) {
      checkList.push({ field: view.$t('SeaExport.consignorDetailAddress'), errorDescription: view.$t('SeaExport.Required') })
    } else if (manifestInfo.shipperAddress.length > 140) {
      checkList.push({ field: view.$t('SeaExport.consignorDetailAddress'), errorDescription: view.$t('SeaExport.maxLength', ['140']) })
    }
    // 发货人国家
    if (!manifestInfo.shipperCountryCode) {
      checkList.push({ field: view.$t('SeaExport.ActualShipperCountry'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 发货人电话
    if (manifestInfo.shipperContactsType !== 0 || !manifestInfo.shipperContacts) {
      checkList.push({ field: view.$t('SeaExport.consignorPhone'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 通知人名称
    if (!manifestInfo.notifyEnterpriseName) {
      checkList.push({ field: view.$t('SeaExport.notifyingName'), errorDescription: view.$t('SeaExport.Required') })
    } else if (manifestInfo.notifyEnterpriseName.length > 140) {
      checkList.push({ field: view.$t('SeaExport.notifyingName'), errorDescription: view.$t('SeaExport.maxLength', ['140']) })
    }
    // 通知人地址
    if (!manifestInfo.notifyAddress) {
      checkList.push({ field: view.$t('SeaExport.notifyingDetailAddress'), errorDescription: view.$t('SeaExport.Required') })
    } else if (manifestInfo.notifyAddress.length > 140) {
      checkList.push({ field: view.$t('SeaExport.notifyingDetailAddress'), errorDescription: view.$t('SeaExport.maxLength', ['140']) })
    }
    // 通知人国家
    if (!manifestInfo.notifyCountryCode) {
      checkList.push({ field: view.$t('SeaExport.NotificationCountry'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 通知人电话
    if (manifestInfo.notifyContactsType !== 0 || !manifestInfo.notifyContacts) {
      checkList.push({ field: view.$t('SeaExport.notifyingPhone'), errorDescription: view.$t('SeaExport.Required') })
    }
    if (!manifestGoods || !manifestGoods.length > 0) {
      checkList.push({ field: view.$t('SeaExport.CargoInfo'), errorDescription: view.$t('SeaExport.Required') })
    }
    // 青岛港，冷冻品的时候需要判断冷冻品提醒
    let ldpWarn = !ifSh && manifestInfo.thirdPartyCargoType === '冷冻品'
    // 青岛港，危险品的时候需要判断危险品提醒
    let wxpWarn = !ifSh && manifestInfo.thirdPartyCargoType === '危险品'
    // 货物信息校验
    if (manifestGoods && manifestGoods.length > 0) {
      for (let i = 0; i < manifestGoods.length; i++) {
        const manifestGood = manifestGoods[i]
        const rowPrefix = view.$t('Message.RowPrefix', [manifestGood.soNo])
        const carrierAgent = manifestInfo.thirdPartyCarrierAgent
        // 关单号校验
        if (!manifestGood.soNo) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.SoNo')}`, errorDescription: view.$t('SeaExport.Required') })
        } else if (manifestGood.soNo.length < 6 || manifestGood.soNo.length > 30) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.SoNo')}`, errorDescription: view.$t('SeaExport.PleaseEnterLength', ['6-30']) })
        }
        // 箱号校验
        if (!manifestGood.containerNo) {
          checkList.push({ field: `${rowPrefix}${view.$t('Payment.containerNo')}`, errorDescription: view.$t('SeaExport.Required') })
        }
        // 箱型校验
        if (!manifestGood.eqSize) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.ContainerSize')}`, errorDescription: view.$t('SeaExport.Required') })
        }
        // 封号校验
        if (!manifestGood.sealNo) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.SealNo')}`, errorDescription: view.$t('SeaExport.Required') })
        }
        // 件数校验
        if (!manifestGood.quantity) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Quantity')}`, errorDescription: view.$t('SeaExport.Required') })
        } else {
          // 最大长度7（字段是int类型的）
          const quantityStr = manifestGood.quantity.toString()
          if (quantityStr.length > 7) {
            checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Quantity')}`, errorDescription: view.$t('SeaExport.maxLength', ['7']) })
          }
        }
        // 毛重校验
        if (!manifestGood.weight) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Weight')}`, errorDescription: view.$t('SeaExport.Required') })
        } else {
          // 三位小数数字范围0.001~1000000.999
          const weight = parseFloat(manifestGood.weight)
          if (weight < 0.001 || weight > 1000000.999) {
            checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Weight')}`, errorDescription: view.$t('Message.CubageRegex') })
          }
        }
        // 体积校验
        if (!manifestGood.cubage) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Cubage')}`, errorDescription: view.$t('SeaExport.Required') })
        } else {
          // 三位小数数字范围0.001-2000.999
          const cubage = parseFloat(manifestGood.cubage)
          if (cubage < 0.001 || cubage > 2000.999) {
            checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Cubage')}`, errorDescription: view.$t('Message.CubageRegex') })
          }
        }
        // 包装校验
        if (!manifestGood.packing) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Package')}`, errorDescription: view.$t('SeaExport.Required') })
        }
        // 唛头校验
        if (!manifestGood.mark) {
          checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.Marks')}`, errorDescription: view.$t('SeaExport.Required') })
        }
        // 英文品名校验
        if (!manifestGood.cargoEnglishName) {
          checkList.push({ field: `${rowPrefix}${view.$t('queryJob.englishDescriptionOfGoods')}`, errorDescription: view.$t('SeaExport.Required') })
        }
        if (!ifSh && carrierAgent === '日照中创' && manifestInfo.thirdPartyCargoType === '危险品') {
          // HSCode校验
          if (!manifestGood.hsCode) {
            checkList.push({ field: `${rowPrefix}HSCode`, errorDescription: view.$t('SeaExport.Required') })
          }
        }
        // 危险品等级校验
        if (manifestGood.danClassNo) {
          const danClass = parseFloat(manifestGood.danClassNo)
          if (isNaN(danClass) || danClass < 1 || danClass > 9.9) {
            checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.DangerousClass')}`, errorDescription: view.$t('Message.DanClass') })
          }
        }

        // 青岛港校验
        if (!ifSh) {
          if (carrierAgent === '远大均胜' || carrierAgent === '海丰船代' || carrierAgent === '日照中创') {
            if (!manifestGood.vgmWeight || manifestGood.vgmWeight === 0.0) {
              checkList.push({ field: `${rowPrefix}${view.$t('SpecialGoods.VgmWeight')}`, errorDescription: view.$t('SeaExport.Required') })
            }
            if (!manifestGood.vgmWeightingMethod) {
              checkList.push({ field: `${rowPrefix}${view.$t('Message.VgmWeightingMethod')}`, errorDescription: view.$t('SeaExport.Required') })
            }
          }
          if (carrierAgent === '远大均胜' && !manifestGood.cargoChineseName) {
            checkList.push({ field: `${rowPrefix}${view.$t('queryJob.chineseDescriptionOfGoods')}`, errorDescription: view.$t('SeaExport.Required') })
          }
        }

        // 危险品相关校验（当货物类型为'危险品'时）
        if (manifestInfo.thirdPartyCargoType === '危险品') {
          let dngrContactNumberCheck = true
          let dngrContactUserCheck = true
          // UN Code校验
          if (!manifestGood.danUNNo) {
            checkList.push({ field: `${rowPrefix}UN Code`, errorDescription: view.$t('SeaExport.Required') })
          }
          // 危险品等级校验
          if (!manifestGood.danClassNo) {
            if (ifSh) {
              checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.DangerousClass')}`, errorDescription: view.$t('SeaExport.Required') })
            }
            dngrContactNumberCheck = false
          }
          // 危险品联系人校验
          if (!manifestGood.dngrContactUser) {
            if (ifSh) {
              checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.DangerousGoodsContact')}`, errorDescription: view.$t('SeaExport.Required') })
            }
            dngrContactUserCheck = false
          }
          // 危险品联系人电话校验
          if (!manifestGood.dngrContactNumber) {
            if (ifSh) {
              checkList.push({ field: `${rowPrefix}${view.$t('SeaExport.DangerousGoodsContactPhoneNumber')}`, errorDescription: view.$t('SeaExport.Required') })
            }
            dngrContactNumberCheck = false
          }
          // UN Code校验
          if (manifestGood.danUNNo && manifestGood.danUNNo.length !== 4) {
            checkList.push({ field: `${rowPrefix}UN Code`, errorDescription: view.$t('SeaExport.MustBe4') })
          }
          if (dngrContactNumberCheck && dngrContactUserCheck) {
            wxpWarn = false
          }
        }

        // 冷冻品、冷藏危品 校验必填
        if (manifestInfo.thirdPartyCargoType === '冷冻品' || manifestInfo.thirdPartyCargoType === '冷藏危品') {
          let tempUnitCheck = true
          let tempCheck = true
          let ventilationCheck = true
          if (!manifestGood.tempUnit) {
            if (ifSh) {
              checkList.push({ field: `${rowPrefix}${view.$t('SpecialGoods.TemperatureUnit')}`, errorDescription: view.$t('SeaExport.Required') })
            }
            tempUnitCheck = false
          }
          if (!manifestGood.temp || manifestGood.temp === 0.0 || manifestGood.temp === -9999) {
            if (ifSh) {
              checkList.push({ field: `${rowPrefix}${view.$t('SpecialGoods.Temp')}`, errorDescription: view.$t('SeaExport.Required') })
            }
            tempCheck = false
          }
          if (!manifestGood.ventilation || manifestGood.temp === 0.0) {
            ventilationCheck = false
          }
          // 青岛港特殊校验
          if (tempUnitCheck && tempCheck && ventilationCheck) {
            ldpWarn = false
          }
        }
      }
      if (ldpWarn) {
        checkList.push({ field: `${view.$t('SpecialGoods.TemperatureUnit')},${view.$t('SpecialGoods.Temp')},${view.$t('SpecialGoods.VentilationWse')}`, errorDescription: view.$t('Message.LdpWarn') })
      }
      if (wxpWarn) {
        checkList.push({ field: `${view.$t('SeaExport.DangerousGoodsContact')},${view.$t('SeaExport.DangerousGoodsContactPhoneNumber')},${view.$t('SpecialGoods.VentilationWse')}`, errorDescription: view.$t('Message.WxpWarn') })
      }
    }
    return checkList
  }
}
